export default {
  TriggerConditions: {
    Title: 'Trigger Conditions',
    UnsupportedRuleMessage: 'This trigger was written by an engineer, contact the engineering department to edit it',
    Resources: {
      Client: 'Client',
      Caregiver: 'Caregiver',
      EventCaregiverUpdate: 'Event caregiver update',
      ClientMessage: 'Client message',
      CaregiverMessage: 'Caregiver message',
    },
    Fields: {
      Status: 'status',
      EventType: 'event type',
      MessageSource: 'message source',
    },
    EventTypes: {
      ShiftConfirmation: 'Shift confirmation',
      ClockInConfirmation: 'Clock in confirmation',
      ClockOutConfirmation: 'Clock out confirmation',
      RequestReschedule: 'Reschedule Request',
      RequestCancel: 'Request Cancel',
      ShiftConfirmationMissed: 'Missed Shift Confirmation',
      ClockInConfirmationMissed: 'Missed Clock in Confirmation',
      ClockOutConfirmationMissed: 'Missed Clock Out Confirmation',
    },
    MessageSources: {
      Email: 'Email',
      Sms: 'SMS',
      Any: 'Any',
    },
  },
  View: {
    Delete: 'Delete',
    Edit: 'Edit',
    Empty: 'Select an automation to view its details.',
    Description: 'Description',
    RecentInvocations: {
      Title: 'Recent Invocations',
      Summary: {
        Invocations: 'Invocations',
        MaxInvocations: '99+',
        Model: 'Model',
        ModelValue: 'Claude Sonnet 4.5',
      },
      Statuses: {
        OPEN: 'Open',
        COMPLETE: 'Complete',
        DELETED: 'Deleted',
        UNKNOWN: 'Unknown',
      },
    },
    TriggerConditions: {
      DeterministicRule: 'Deterministic Rule',
      AiRule: 'AI-Evaluated Rule',
    },
    Assignees: 'Assignees',
    NoneAssigned: 'None Assigned',
    None: 'None',
    Prompt: 'Prompt',
  },
  List: {
    Title: 'Automations',
    Subtitle: 'Auto-Generate Tasks',
    NewAutomation: '+ New',
    Loading: 'Loading automations...',
    Empty: 'No automations found.',
  },
  New: {
    Eyebrow: 'Define the automation',
    Title: 'What should this automation do?',
    Steps: {
      Basic: {
        Title: 'Basic',
        NameTitle: 'Automation Name',
        NamePlaceholder: 'e.g., Call New Client Lead',
        DescriptionTitle: 'Description',
        DescriptionPlaceholder:
          'Provide a high-level description of this task-generation automation. ' +
          '\n e.g. "Create a task to call new client leads 10 minutes after they sign up."',
        GroupLabel: 'Add to group',
        GroupMode: {
          Existing: 'Existing group',
          New: 'Create new',
        },
        NewGroupPlaceholder: 'E.g. Client Messaging',
      },
      Rules: {
        Title: 'Rules',
        TriggerConditions: {
          EventResourcePrepend: 'When',
          PropertyInfix: 'changes to',
          EventInfix: 'happens on a',
          MessageInfix: 'is sent on',
        },
        AiEvaluatedRuleTitle: 'AI-Evaluated Rule',
        AiEvaluatedRulePlaceholder:
          'Provide a clear rule the AI should use to decide whether this event should create the task.' +
          '\n e.g. The rule should pass if the client has indicated in any way that they wish to unsubscribe from emails.',
        AssignedToTitle: 'Assigned To',
        PromptTitle: 'Prompt',
        PromptPlaceholder:
          'Provide explicit instructions for the task you want the system to auto-generate for you.' +
          '\n Optionally indicate the due date of the task, either relative to the event or a specific date and time. ' +
          'If no indication of due date is provided, the due date will default to 11:59 pm EST.' +
          '\n e.g. "Create a task for me to call this client lead 10 minutes after they sign up. Provide a call brief if you are able to."',
      },
    },
    Actions: {
      Cancel: 'Cancel',
      Next: 'Next',
      Back: 'Back',
      Create: 'Create automation',
    },
  },
};
